/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateStationComponentDto } from './create-station-component-dto';
import { EnDesktopPlatform } from './en-desktop-platform';
import { EnStationType } from './en-station-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateStationDto
 */
export interface CreateStationDto {

    /**
     * Human-readable name for the kiosk (e.g. \"Kiosk Floor 2 - Room 4\")
     *
     * @type {string}
     * @memberof CreateStationDto
     */
    name: string;

    /**
     * @type {EnStationType}
     * @memberof CreateStationDto
     */
    type: EnStationType;

    /**
     * @type {EnDesktopPlatform}
     * @memberof CreateStationDto
     */
    platform: EnDesktopPlatform;

    /**
     * OS version (e.g. \"Windows 11 23H2\", \"Ubuntu 24.04\", \"macOS 14.4\")
     *
     * @type {string}
     * @memberof CreateStationDto
     */
    systemVersion?: string;

    /**
     * Unity app version (e.g. \"1.0.0\")
     *
     * @type {string}
     * @memberof CreateStationDto
     */
    appVersion?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateStationDto
     */
    client?: JoinEntityDto;

    /**
     * @type {Array<CreateStationComponentDto | JoinEntityDto>}
     * @memberof CreateStationDto
     */
    components: Array<CreateStationComponentDto | JoinEntityDto>;

    /**
     * @type {string}
     * @memberof CreateStationDto
     */
    note?: string;
}
